import { render, staticRenderFns } from "./FileThumbnail.vue?vue&type=template&id=229abaa6&scoped=true&"
import script from "./FileThumbnail.vue?vue&type=script&lang=js&"
export * from "./FileThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./FileThumbnail.vue?vue&type=style&index=0&id=229abaa6&lang=scss&scoped=true&"
import style1 from "./FileThumbnail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229abaa6",
  null
  
)

export default component.exports